import React from "react";
import Header from "./header.jsx";
import Footer from "./footer.jsx";
import Contenido from "./contenido.jsx";
import Diseno from "./diseno.jsx";
import Plantilla from "./nuevodisenoreceta.jsx";

function App() {
  return (
    <div className="App">
      <Header />
      <Contenido />
      <Footer />
    </div>
  );
}

export default App;
